var map = {
  "./desktop/index.js": [
    "59908",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "8384",
    "13359"
  ],
  "./desktop/index": [
    "59908",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "8384",
    "13359"
  ],
  "./mobile": [
    "38474",
    "76225",
    "61301",
    "30831",
    "47387",
    "3199",
    "77996",
    "50437",
    "68454",
    "44944",
    "17189",
    "8384",
    "5113"
  ],
  "./desktop": [
    "59908",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "8384",
    "13359"
  ],
  "./desktop/": [
    "59908",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "8384",
    "13359"
  ],
  "./mobile/": [
    "38474",
    "76225",
    "61301",
    "30831",
    "47387",
    "3199",
    "77996",
    "50437",
    "68454",
    "44944",
    "17189",
    "8384",
    "5113"
  ],
  "./mobile/index": [
    "38474",
    "76225",
    "61301",
    "30831",
    "47387",
    "3199",
    "77996",
    "50437",
    "68454",
    "44944",
    "17189",
    "8384",
    "5113"
  ],
  "./mobile/index.js": [
    "38474",
    "76225",
    "61301",
    "30831",
    "47387",
    "3199",
    "77996",
    "50437",
    "68454",
    "44944",
    "17189",
    "8384",
    "5113"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 83649;
module.exports = __rspack_async_context;
